import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Button } from "reactstrap";
import { Modal, ModalDialog } from "react-bootstrap";
import { sendData, defaultHeaders } from "../../../services/auth";
import { useSelector } from "react-redux";
import { InputLabelAlert } from "../../../common/layout";
import { uriList } from "../../../helpers/config";
import { width, SimNao } from "../../../helpers";
import Select from 'react-select'
import Draggable from "react-draggable";
let tipos = [
    { value: 'DOCUMENTO', name: 'Documento' },
    { value: 'CHECKLIST', name: 'CheckList' },
    { value: 'OUTROS', name: 'Outros' },
]

// const customStyles = {
//     menu: base => ({
//         ...base,
//         height: "30px !important",
//     }),
// }

class DraggableModalDialog extends React.Component {
    render() {
        return (
            <Draggable handle=".modal-header">
                <ModalDialog {...this.props} />
            </Draggable>
        );
    }
}


const InclusaoRequisitos = (props) => {
    const [data, setData] = useState({})
    const [gravando, setGravando] = useState(false)
    const _login = useSelector((state) => state.login);
    const [validated, setValidated] = useState(false)
    const [gravou, setGravou] = useState(false)
    const [selectedTipos, setSelectedTipos] = useState(null)
    const [tiposDoc, setTiposDoc] = useState([])

    useEffect(() => {
        console.log("InclusaoRequisitos.useEffect:", props.data)
        if (props.data) {
            let _data = {
                id: props.data.ID,
                empresaid: props.data.EMPRESAID,
                clienteid: props.data.CLIENTEID,
                usuarioi_id: props.data.USUARIOI_ID,
                usuarioa_id: props.data.USUARIOA_ID,
                tipo_documentoid: props.data.TIPO_DOCUMENTOID,
                tipo: props.data.TIPO,
                limitador: props.data.LIMITADOR
            }

            console.log("InclusaoRequisitos.useEffect(1):", _data)
            setData(_data)
        }
        else
            setData({
                empresaid: props.empresaid || _login.empresaid,
                clienteid: 0,
                tipo_documentoid: 0,
                usuarioi_id: 0,
                usuarioa_id: 0,
                tipo: 'DOCUMENTO',
                limitador: 'NAO'
            })

        carregarDados()
    }, [])

    async function carregarDados() {
        let _tiposDoc = props.tipos?.map((item, key) => { return { value: item.ID, label: item.NOME } });
        setTiposDoc(_tiposDoc)
        console.log("InclusaoRequisitos.carregarDados(tipos):", _tiposDoc)
        // await sendData({ uri: uriList("integracoes"), content: { id: props.data.ID } })
        // .then((res) => {
        //     console.log("Integracoes: ", res.data);

        //     if (res.status && parseInt(res.status) > 200) throw new Error();
        // })
        // .catch((e) => {
        //     console.log(e);
        //     // alert("Erro ao obter Integracoes.\n" + e.message);
        // });
    }

    function validarDados(event) {
        const form = document.getElementById('form-upload-Requisitos')
        console.log("InclusaoRequisitos.validarDados(form): ", form)
        setValidated(false)
        const isValid = form.checkValidity()
        if (!isValid) {
            event.preventDefault()
            event.stopPropagation()
        }

        setValidated(true)
        return isValid
    }

    function handlePost(e, isClosed) {
        if (!validarDados(e))
            return
        setGravando(true)
        e.preventDefault()

        // let selectElement = document.getElementById('tipo_documentoid')
        let selectedValues = null
        if (selectedTipos)
            selectedValues = Array.from(selectedTipos)?.map(option => option.value)
        console.log("InclusaoRequisitos-selectedValues: ", selectedValues)

        console.log("InclusaoRequisitos.handlePost(1): ", _login.empresaid)

        let formData = new FormData()
        if (data.id && data.id != undefined)
            formData.append('id', data.id)
        formData.append('empresaid', _login.empresaid || props.empresa);
        formData.append('clienteid', data.clienteid);
        formData.append('usuarioid', _login.usuarioid || props.usuario);
        formData.append('tipo_documentoid', data.tipo == "CHECKLIST" ? null : data.tipo_documentoid);
        formData.append('tipo', data.tipo);
        formData.append('limitador', data.limitador);
        if (selectedValues)
            formData.append('tipos', selectedValues);

        console.log("InclusaoRequisitos.handlePost(Dados): ", data)

        axios({
            url: uriList("requisitosAdd"),
            method: 'POST',
            headers: defaultHeaders(),
            data: formData
        })
            .then(res => {
                setGravando(false)
                console.log("Registro gravado: ", res)
                if (data.id && props.onCloseEv)
                    props.onCloseEv(true)
                else {
                    setData({})
                    setGravou(true)
                }
                if (isClosed)
                  handleClose()
            })
            .catch(error => {
                setGravando(false)
                console.log("Erro ao gravar registro: ")
                console.log(error)
            })
    }

    function handleClose() {
        if (props.onCloseEv)
            props.onCloseEv(gravou)
    }

    function handleChange(e) {
        console.log("InclusaoRequisitos.handleChange: ", e.target.id, e.target.value)
        let target = e.currentTarget;
        let name = target.id || target.name;
        let value = target.value?.toUpperCase();
        // console.log("InclusaoRequisitos.handleChange: ", target)
        setData({ ...data, [name]: value });
        if (name == 'tipo_documentoid') {
            console.log("InclusaoRequisitos.handleChange(itens): ", props.tipos)
            let _sel = props.tipos.filter(item => item.ID == value)
            console.log("InclusaoRequisitos.handleChange(sel): ", _sel)
            if (_sel[0]?.LIMITADOR == 'SIM')
                setData({ ...data, limitador: 'SIM' });
        }
    }

    function handleTipoDoc(e) {
        let _sel = e
        setSelectedTipos(e)
        console.log(`handleTipoDoc: `, _sel);
    }

    return (
        <>
            <Modal
                size={width() == "mobile" ? "md" : "lg"}
                show={true}
                onHide={handleClose}
                centered
                animation={false}
                dialogAs={DraggableModalDialog}
                backdrop="static"
            >
                <Modal.Header closeButton >
                    <Modal.Title>
                        <span>Cadastro de Requisitos</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="maxWidth750">
                    {gravando ? (
                        <div>Gravando registro...</div>
                    ) : (

                        <form className={`form g-2 p-2 border needs-validation ${validated ? ' was-validated ' : ''}`} noValidade
                            id="form-upload-Requisitos">

                            <div className="row g-1">
                                <div className="form-group col-md-12">
                                    <label className="m-0 font-90">Cliente</label>
                                    <select className="form-control"
                                        onChange={(e) => setData({ ...data, clienteid: e.target.value })} required id="clienteid">
                                        {/* {buscandoClientes ? <option value="" selected={true}>Buscando Clientes...</option> : */}
                                        <>
                                            <option value="" selected={!data.clienteid}>Escolha um cliente...</option>
                                            {props.clientes?.map((item, key) => {
                                                if (item.NOME)
                                                    return (
                                                        <option key={item.PESSOAID} value={item.PESSOAID} selected={data.clienteid == item.PESSOAID}>
                                                            {item.NOME + " - " + item.CNPJ_CPF}</option>
                                                    )
                                            })}
                                        </>

                                    </select>
                                </div>
                            </div>

                            <div className='row g-1' >
                                <div className={`form-group ${width() == 'mobile' ? "col-12" : "col-md-3"}`} >
                                    <label className="m-0 font-90">Tipo</label>

                                    <div style={{ height: "100%" }}>
                                        <select className="form-control select-full" id="tipo"
                                            onChange={e => setData({ ...data, tipo: e.target.value })} required >
                                            <>
                                                <option value="" selected={!data.tipo}>Escolha uma Tipo...</option>
                                                {tipos?.map((item, key) => {
                                                    return (
                                                        <option key={key} value={item.value} selected={data.tipo == item.value}>{item.name}</option>
                                                    )
                                                })}
                                            </>

                                        </select>
                                    </div>
                                </div>
                                {(!data.tipo || data.tipo != "CHECKLIST") &&
                                    <div className={`form-group ${width() == 'mobile' ? "col-12" : "col-md-6"}`} >
                                        <label className="m-0 font-90">Tipo de Documento</label>
                                        {!data.id &&
                                            <Select
                                                // classNamePrefix='select-filter'                                            
                                                options={tiposDoc}
                                                placeholder="Selecione o tipo de documento..."
                                                value={selectedTipos}
                                                onChange={handleTipoDoc}
                                                isSearchable={true}
                                                isMulti
                                            // styles={customStyles}
                                            />
                                        }
                                        {data.id &&
                                            <div style={{ height: "100%" }}>
                                                <select className="form-control select-full" id="tipo_documentoid"
                                                    onChange={handleChange} required >
                                                    <>
                                                        <option value="" selected={!data.tipo_documentoid}>Escolha uma Tipo...</option>
                                                        {props.tipos?.map((item, key) => {
                                                            return (
                                                                <option key={key} value={item.ID} selected={data.tipo_documentoid == item.ID}>{item.NOME}</option>
                                                            )
                                                        })}
                                                    </>
                                                </select>
                                            </div>
                                        }
                                    </div>}
                                <div className={`form-group ${width() == 'mobile' ? "col-12" : "col-md-3"}`} >
                                    <label className="m-0 font-90">Limitador</label>
                                    <div style={{ height: "100%" }}>
                                        <select className="form-control select-full" id="limitador"
                                            onChange={e => setData({ ...data, limitador: e.target.value })} required >
                                            <>
                                                <option value="" selected={!data.limitador}>Escolha uma Limitador...</option>
                                                {SimNao?.map((item, key) => {
                                                    return (
                                                        <option key={key} value={item.value} selected={data.limitador == item.value}>{item.label}</option>
                                                    )
                                                })}
                                            </>

                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button color="success" onClick={e => {handlePost(e,false)}}>
                        {/* <Button color="success" type="submit"> */}
                        Gravar
                    </Button>
                    <Button color="success" onClick={e => {handlePost(e,true)}} >
                            Gravar e Fechar
                    </Button>
                    <Button color="secondary" onClick={handleClose}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default InclusaoRequisitos;